<template>

  <div class="main" id="main"  >
    <Top/>
    <div class="error-page">
      <div class="pic-404">
        <img class="pic-404__parent" src="/static/assets/404.png" alt />
      </div>
      <div class="notFound">
        <span>啊哦~~~你访问的页面不存在哦</span>
        <span>
        你可以尝试
        <a class="link" @click="$router.go(-1)">返回上一页</a>
      </span>
      </div>
      <div style="clear: both" ></div>
    </div>
  </div>
</template>

<script >
  import Top from '@/components/top.vue'
export default {
  components: {
    Top
  },
}
</script>

<style  scoped>
.error-page {
  height: 100%;
  display: flex;


}
.pic-404 {
  text-align: center;
  width: 60%;
  padding: 50px;

}
.pic-404__parent {
  width: 600px;
}
.notFound {
  padding: 150px 0;
  overflow: hidden;

}
.notFound span {
  display: block;
  line-height: 60px;
  font-size: 18px;
  color: #8b7b8b;

}
.notFound span .link {
  color: #5cacee;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue